import { Box, Button, Collapse, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { PropsWithChildren } from "react";
import { lowerCase } from "lodash";

type SectionCollapsibleProps = PropsWithChildren<{
  label: string;
  open?: boolean;
  filter?: boolean;
}>;

const SectionCollapsible = ({
  children,
  label,
  open = true,
  filter = false,
}: SectionCollapsibleProps) => {
  const [isExpanded, setExpanded] = React.useState<boolean>(open);

  return (
    <>
      <Box
        data-testid={`${lowerCase(label)}-header-container`}
        onClick={(e) => {
          e.stopPropagation();
          setExpanded(!isExpanded);
        }}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
      >
        {filter ? (
          <Button type="button" variant="outlined">
            {label}
          </Button>
        ) : (
          <Typography variant={"h5"} align="left">
            {label}
          </Typography>
        )}
        <ExpandMoreIcon
          data-testid="expand-icon"
          fontSize="large"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(!isExpanded);
          }}
          sx={{
            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
            "&:hover": { cursor: "pointer" },
          }}
        />
      </Box>
      <Collapse sx={{ padding: 2 }} in={isExpanded}>
        {children}
      </Collapse>
    </>
  );
};

export default SectionCollapsible;
